import React from 'react'
import { Container, Label, Name, Description } from './styles'
import { Complement } from '../Complement'

const EMPTY = ''

interface IProps {
  title: string
  description: string
  complement?: string
}

export const NoteProperty = ({ title, description, complement }: IProps): JSX.Element => {
  return (
    <Container>
      <Label>
        <Name>{`${title.trim()}: `}</Name>
        <Description>{`${description.trim()}`}</Description>
      </Label>

      <Complement text={complement ?? EMPTY} />
    </Container>
  )
}
